'use client';

import dynamic from 'next/dynamic';

//* Styles
import TaxationSystemTemplateStyle from './style';

//* Components
import NewHeroSection from '../../BusinessRegistration/components/NewHeroSection';
const List = dynamic(() => import('../components/List'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const FAQSection = dynamic(() => import('@/sections/FAQSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const TaxationSystemTemplate = ({ pageData }) => {
	const { content, faqs } = pageData;

	return (
		<TaxationSystemTemplateStyle>
			<NewHeroSection
				title={content.title}
				description={content.description}
				desktop_image={content.desktop_image}
				mobile_image={content.mobile_image}
			/>

			<List
				items={content.taxes_percents}
				tax={content.tax}
			/>

			<FAQSection items={faqs} />
		</TaxationSystemTemplateStyle>
	);
};

export default TaxationSystemTemplate;
